import $ from 'jquery'
import Draw from 'ol/interaction/Draw'
import Feature from 'ol/Feature'
import Overlay from 'ol/Overlay'
import OL3Parser from 'jsts-ie/org/locationtech/jts/io/OL3Parser'
import BufferOp from 'jsts-ie/org/locationtech/jts/operation/buffer/BufferOp'
import BufferParameters from 'jsts-ie/org/locationtech/jts/operation/buffer/BufferParameters'
import Tool from '../Tool'
import drawLayer from '../drawLayer'
import UndoVertex from './UndoVertex'
import defaultDrawStyle from './defaultDrawStyle'
import {
  Point,
  LineString,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  LinearRing,
  GeometryCollection
} from 'ol/geom'

//TODO
import * as ol from 'ol'

/**
 * BufferedLine tool class
 * @param {Object} config
 * @constructor
 */
export default class BufferedLine extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)
    this.$popover = $(`<div class="popover top in">
        <div class="arrow"></div>
        <div class="popover-header">
          <a class="close popover-close"><i class="fa fa-eye icon-only"></i></a>
        </div>
        <div class="popover-content">
            <fieldset class="form-horizontal">
                <div class="form-group"></div>
            </fieldset>
        </div>
        <div class="popover-footer">
            <div class="btn-toolbar"></div>
        </div>
    </div>`)
    this.ui.iconClass = 'map-line'
    this.drawSource = drawLayer.getSource()
    this.interaction = new Draw({
      source: this.drawSource,
      type: 'LineString',
      style: this.style || defaultDrawStyle()
    })

    this.drawEvent = null
    this.parser = new OL3Parser()
    this.parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon,
      GeometryCollection
    )
    this.distance =
      this.options && this.options.defaultWidth ? this.options.defaultWidth : 30
    this.bufferParams = new BufferParameters()
    this.bufferParams.setEndCapStyle(BufferParameters.CAP_FLAT)
    // this.bufferParams.setJoinStyle(BufferParameters.JOIN_MITRE)
    this.polygonFeature = new Feature()
    this.lineFeature = new Feature()

    this.$header = this.$popover.find('.popover-header:first')
    this.$header.append($(`<h3 class="popover-title">Ange bredd (m)</h3>`))
    this.$header.on('mousedown', this.handleHeaderMousedown.bind(this))
    this.$header.css('user-select', 'none')
    this.$header.on('mouseup mouseleave', this.handleHeaderMouseup.bind(this))

    this.$input = $(`<input type="number" class="form-control input-sm">`)
    this.$input.appendTo(this.$popover.find('.form-group:first'))
    this.$input.val(this.distance)
    this.$popover.css({
      width: 180,
      'min-width': 'initial',
      'max-width': 'initial'
    })
    this.$input.on('input', this.handleDistanceChange.bind(this))
    this.$input.on('keypress', this.handleInputKeypress.bind(this))

    this.$cancelButton = $(
      `<button type="button" class="btn btn-default btn-sm">Avbryt</button>`
    )
    this.$cancelButton.appendTo(this.$popover.find('.btn-toolbar:first'))
    this.$cancelButton.on('click', this.handleCancelButtonClick.bind(this))

    this.$confirmButton = $(
      `<button type="button" class="btn btn-primary btn-sm">OK</button>`
    )
    this.$confirmButton.appendTo(this.$popover.find('.btn-toolbar:first'))
    this.$confirmButton.on('click', this.handleConfirmButtonClick.bind(this))

    this.overlay = new Overlay({
      element: this.$popover.get(0),
      offset: [-89, -145],
      autoPan: true,
      autoPanAnimation: { duration: 200 },
      autoPanMargin: 5
    })
    this.map.addOverlay(this.overlay)

    this.drawStartApiTrigger = this.api.draw.createTrigger()
    this.drawEndApiTrigger = this.api.draw.createTrigger()

    this.useSnap = true

    this.undoVertex = new UndoVertex(this.interaction, this.map)

    this.interaction.on('drawstart', this.handleDrawStart.bind(this))
    this.interaction.on('drawend', this.handleDrawEnd.bind(this))
  }

  handleHeaderMousedown() {
    this.$popover.fadeTo(200, 0.1)
  }

  handleHeaderMouseup() {
    this.$popover.fadeTo(200, 1)
  }

  handleCancelButtonClick() {
    this.overlay.setPosition(undefined)
    this.interaction.setActive(true)
    this.drawSource.removeFeature(this.polygonFeature)
    this.drawSource.removeFeature(this.lineFeature)
  }

  handleConfirmButtonClick() {
    this.overlay.setPosition(undefined)
    this.interaction.setActive(true)

    this.drawEndApiTrigger(
      Object.assign({}, this.drawEvent, {
        feature: this.polygonFeature,
        originalFeature: this.lineFeature
      })
    )
    this.drawSource.removeFeature(this.lineFeature)
  }

  handleInputKeypress(e) {
    const code = e.keyCode || e.which
    if (code === 13) {
      this.handleConfirmButtonClick()
    }
  }

  handleDistanceChange(e) {
    const value = parseFloat(e.target.value)
    if (!isNaN(value)) {
      this.distance = value
      this.updateLineBuffer()
    }
  }

  updateLineBuffer() {
    const jstsGeom = this.parser.read(this.lineFeature.getGeometry())
    const buffered = BufferOp.bufferOp(
      jstsGeom,
      this.distance / 2,
      this.bufferParams
    )
    this.polygonFeature.setGeometry(this.parser.write(buffered))
  }

  handleDrawStart(e) {
    this.drawEvent = e
    this.polygonFeature = new Feature()
    this.lineFeature = e.feature
    this.drawSource.addFeature(this.polygonFeature)
    this.drawStartApiTrigger(e)
    this.undoVertex.activate()
  }

  handleDrawEnd(e) {
    this.drawEvent = e
    this.lineFeature = e.feature
    const coord = this.lineFeature.getGeometry().getLastCoordinate()
    this.overlay.setPosition(coord)
    this.updateLineBuffer()
    this.$input.focus()

    // Hack to prevent double click zoom
    setTimeout(() => this.interaction.setActive(false), 0)
    this.undoVertex.deactivate()
  }

  deactivate() {
    super.deactivate()
    this.undoVertex.deactivate()
  }
}
